// ExamResultForm.jsx – Session-Based Version
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import colors from '../Constant/colors.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import LoadingButton from './LoadingButton.jsx';
const ExamResultForm = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState('');
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState('');
  const [students, setStudents] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subjectMarks, setSubjectMarks] = useState({});
  const [scores, setScores] = useState({});
  const [remarks, setRemarks] = useState({});
  const [examResults, setExamResults] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingResultId, setEditingResultId] = useState('');
  const [viewingResult, setViewingResult] = useState(null);
  const [showReportCard, setShowReportCard] = useState(false);
   const currentSessionId = localStorage.getItem("currentSessionId");
  const [loading, setLoading] = useState(false);
  const labelStyle = "block text-black font-semibold text-[18px] mb-1";
  const inputBase = "w-full px-3 py-2 rounded-lg focus:outline-none placeholder:text-[14px] placeholder:text-gray-400 text-[14px] bg-white";
  const inputBorder = { border: `1px solid #1E40AF` };
  const button18 = { fontSize: "18px", padding: "12px 26px", borderRadius: "8px", fontWeight: "600", cursor: "pointer" };
  

    console.log(localStorage.getItem("currentSessionId"));
  // Fetch classes and exam results once session is loaded
  useEffect(() => {
    if (!currentSessionId) return;

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${currentSessionId}`, {
    }).then(res => setClasses(res.data));

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/getAllExamResults`, {
      params: { sessionId: currentSessionId }
    }).then(res => setExamResults(res.data));
  }, [currentSessionId]);

  // Fetch sections, exams, and subjects when class changes
useEffect(() => {
  if (!selectedClass || !currentSessionId) {
    setSections([]);
    setExams([]);
    setSubjects([]);
    setSubjectMarks({});
    return;
  }

  // Fetch sections
  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`, {
    params: { sessionId: currentSessionId }
  })
  .then(res => {
    if(res.data.length === 0) {
      alert(`No sections available for class ${selectedClass}`);
    }
    setSections(res.data);
  })
  .catch(err => {
    console.error(err);
    alert(`Failed to fetch sections for class ${selectedClass}`);
    setSections([]);
  });

  // Fetch exams
  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/exams/getExamByClass/${selectedClass}`, {
    params: { sessionId: currentSessionId }
  })
  .then(res => {
    if(res.data.length === 0) {
      alert(`No exams available for class ${selectedClass}`);
    }
    setExams(res.data);
  })
  .catch(err => {
    console.error(err);
    alert(`No exams found for class ${selectedClass}`);
    setExams([]);
  });

  // Fetch subjects
  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${selectedClass}`, {
    params: { sessionId: currentSessionId }
  })
  .then(res => {
    setSubjects(res.data);
    const marks = {};
    res.data.forEach(sub => marks[sub.subjectName] = sub.totalMarks || 0);
    setSubjectMarks(marks);
  })
  .catch(err => {
    console.error(err);
    setSubjects([]);
    setSubjectMarks({});
  });

}, [selectedClass, currentSessionId]);


  // Fetch students based on selected class and section
  
useEffect(() => {
  if (isEditing) return;

  if (!selectedClass || !currentSessionId) {
    setSubjects([]);
    setSubjectMarks({});
    setStudents([]);
    return;
  }

  // 🔹 SUBJECTS FETCH
  axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${selectedClass}`,
      {
        params: { sessionId: currentSessionId },
      }
    )
    .then((res) => {
      setSubjects(res.data);

      const marks = {};
      res.data.forEach((sub) => {
        marks[sub.subjectName] = sub.totalMarks || 0;
      });
      setSubjectMarks(marks);
    })
    .catch((err) => console.error("Error fetching subjects:", err));

  // 🔹 STUDENTS FETCH (ADD THIS PART)
  if (selectedSection) {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
        params: {
          sessionId: currentSessionId,
          class: selectedClass,
          section: selectedSection,
        },
      })
      .then((res) => {
        setStudents(res.data);
      })
      .catch((err) => console.error("Error fetching students:", err));
  }

}, [selectedClass, selectedSection, currentSessionId, isEditing]);




  const handleSubjectMarksChange = (subject, value) =>
    setSubjectMarks(prev => ({ ...prev, [subject]: value }));

  const handleSAMarksChange = (studentId, subject, value) => {
    setScores(prev => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [subject]: {
          ...prev[studentId]?.[subject],
          sa: value,
        },
      },
    }));
  };

  const handleAssessmentChange = (studentId, subject, value) => {
    setScores(prev => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [subject]: {
          ...prev[studentId]?.[subject],
          assessment: value,
        },
      },
    }));
  };

  const handleRemarkChange = (studentId, value) =>
    setRemarks(prev => ({
      ...prev,
      [studentId]: value,
    }));

  const getSubjectTotal = (studentId, subject) => {
    const sa = parseFloat(scores[studentId]?.[subject]?.sa) || 0;
    const assessment =
      parseFloat(scores[studentId]?.[subject]?.assessment) || 0;

    return sa + assessment;
  };

  const calculateTotal = studentId => {
    return Object.keys(subjectMarks).reduce(
      (sum, subject) => sum + getSubjectTotal(studentId, subject),
      0
    );
  };

  const calculatePercentage = studentId => {
    const total = calculateTotal(studentId);

    const maxTotal = Object.values(subjectMarks).reduce(
      (sum, m) => sum + (parseFloat(m) || 0),
      0
    );

    return maxTotal
      ? ((total / maxTotal) * 100).toFixed(2)
      : "0.00";
  };

  const resetForm = () => {
    setSelectedClass('');
    setSelectedSection('');
    setSelectedExam('');
    setSubjects([]);
    setSubjectMarks({});
    setStudents([]);
    setScores({});
    setRemarks({});
    setIsEditing(false);
    setEditingResultId('');
  };

 const handleSubmit = () => {
  setLoading(true);

  if (!selectedClass || !selectedSection || !selectedExam) {
    alert("Please select Class, Section, and Exam.");
    setLoading(false);
    return;
  }

  if (!students || students.length === 0) {
    alert("No students found for the selected Class and Section.");
    setLoading(false);
    return;
  }

  if (!subjects || subjects.length === 0) {
    alert("Please add at least one subject.");
    setLoading(false);
    return;
  }

  const data = {
    sessionId: currentSessionId,
    examName: selectedExam,
    className: selectedClass,
    sectionName: selectedSection,
    subjects: subjects.map(s => ({
      subjectName: s.subjectName,
      totalMarks: subjectMarks[s.subjectName] || 0,
    })),
    students: students.map(st => ({
      studentId: st._id,
      rollNo: st.rollNo,
      studentName: `${st.firstName} ${st.lastName}`,
      scores: Object.keys(subjectMarks).map(sub => {
        const sa =
          parseFloat(scores[st._id]?.[sub]?.sa) || 0;

        const assessment =
          parseFloat(scores[st._id]?.[sub]?.assessment) || 0;

        return {
          subjectName: sub,
          sa,
          assessment,
          score: sa + assessment,
        };
      }),
      remark: remarks[st._id] || "",
    })),
  };

  const req = isEditing && editingResultId
    ? axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/updateExamResult/${editingResultId}`, data)
    : axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/createExamResult`, data);

  req
    .then((res) => {
      const updatedResult = res.data;

      if (isEditing) {
        // Backend se updated result ko local list me bhi update rakho
        setExamResults(prev =>
          prev.map(item =>
            item._id === editingResultId ? updatedResult : item
          )
        );
      } else if (updatedResult) {
        // New result ko saved list me add karo
        setExamResults(prev => [updatedResult, ...prev]);
      }

      alert(isEditing ? "Result updated" : "Result added");
      resetForm();
    })
    .catch((error) => {
      console.error("Exam result save/update error:", error);
      alert(error?.response?.data?.message || "Operation failed");
    })
    .finally(() => {
      setLoading(false);
    });
};


 const handleEdit = id => {
  const res = examResults.find(r => r._id === id);
  if (!res) return;

  setSelectedClass(res.className);
  setSelectedSection(res.sectionName);
  setSelectedExam(res.examName);

  setSubjects(res.subjects);

  const scoresMap = {};
  const remarksMap = {};

  // Saved result ke students ko edit form ke student format me load karo
  // taaki edit ke time bhi same students aur unke marks visible rahein.
  const editStudents = (res.students || []).map(st => {
    const studentId =
      st.studentId?._id ||
      st.studentId;

    const fullName = st.studentName || '';
    const nameParts = fullName.trim().split(/\s+/);
    const firstName = nameParts.shift() || '';
    const lastName = nameParts.join(' ');

    scoresMap[studentId] = {};

    (st.scores || []).forEach(s => {
      const hasSA =
        s.sa !== undefined && s.sa !== null;
      const hasAssessment =
        s.assessment !== undefined && s.assessment !== null;

      scoresMap[studentId][s.subjectName] = {
        // New records: SA + Assessment
        // Old records: score ko SA me fallback karo so old data bhi lost na ho.
        sa: hasSA
          ? s.sa
          : (s.saMarks ?? (!hasAssessment ? (s.score ?? 0) : 0)),
        assessment: hasAssessment
          ? s.assessment
          : (s.assessmentMarks ?? 0),
      };
    });

    remarksMap[studentId] = st.remark || '';

    return {
      _id: studentId,
      rollNo: st.rollNo,
      firstName,
      lastName,
      studentName: fullName,
    };
  });

  // Edit mode me students API se dobara empty na ho; saved result ke students show karo.
  setStudents(editStudents);
  setScores(scoresMap);
  setRemarks(remarksMap);

  const subjMarks = {};
  res.subjects.forEach(s => {
    subjMarks[s.subjectName] = s.totalMarks;
  });
  setSubjectMarks(subjMarks);

  setIsEditing(true);
  setEditingResultId(id);
};


  const handleDelete = id => {
    if (!window.confirm("Delete result?")) return;
    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/deleteExamResult/${id}`, {
      params: { sessionId: currentSessionId }
    }).then(() => setExamResults(prev => prev.filter(r => r._id !== id)));
  };

  // PDF generation function unchanged
  const generatePDFReportCardForStudent = (examResult, studentId) => {
    const container = document.getElementById("pdf-reportcard-container");
    if (!container) return alert("PDF container not found!");

    const subjects = examResult.subjects;
    const student = examResult.students.find(st => st.studentId === studentId);
    if (!student) return alert("Student not found!");

    container.innerHTML = "";

    const totalMarks = student.scores.reduce((sum, s) => sum + (parseFloat(s.score) || 0), 0);
    const maxTotal = subjects.reduce((sum, s) => sum + (Number(s.totalMarks) || 0), 0);
    const percentage = maxTotal ? ((totalMarks / maxTotal) * 100).toFixed(2) : "0.00";

    const card = document.createElement("div");
    card.style.width = "800px";
    card.style.padding = "20px";
    card.style.border = "2px solid #1E40AF";
    card.style.marginBottom = "40px";
    card.style.fontFamily = "Arial, sans-serif";
    card.style.backgroundColor = "#fff";
    card.style.color = "#000";
    card.innerHTML = `
      <h1 style="text-align: center; color: #1E40AF; margin-bottom: 10px;">SA1 Report Card</h1>
      <h3 style="text-align: center; margin: 0 0 20px 0;">Class: ${examResult.className} | Section: ${examResult.sectionName} | Exam: ${examResult.examName}</h3>
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr style="background-color: #e2e8f0;">
            <th style="border: 1px solid #1E40AF; padding: 8px;">#</th>
            <th style="border: 1px solid #1E40AF; padding: 8px;">Subject</th>
            <th style="border: 1px solid #1E40AF; padding: 8px;">Total Marks</th>
            <th style="border: 1px solid #1E40AF; padding: 8px;">Marks Obtained</th>
          </tr>
        </thead>
        <tbody>
          ${subjects.map((sub, i) => `
            <tr style="background-color: ${i % 2 === 0 ? "#f9fafb" : "#fff"};">
              <td style="border: 1px solid #1E40AF; padding: 8px; text-align: center;">${i+1}</td>
              <td style="border: 1px solid #1E40AF; padding: 8px;">${sub.subjectName}</td>
              <td style="border: 1px solid #1E40AF; padding: 8px; text-align: center;">${Number(sub.totalMarks)}</td>
              <td style="border: 1px solid #1E40AF; padding: 8px; text-align: center;">${student.scores.find(s => s.subjectName === sub.subjectName)?.score || 0}</td>
            </tr>`).join('')}
          <tr style="font-weight:bold; background-color:#e2e8f0;">
            <td colspan="2" style="border:1px solid #1E40AF; padding:8px; text-align:right;">Total</td>
            <td style="border:1px solid #1E40AF; padding:8px; text-align:center;">${maxTotal}</td>
            <td style="border:1px solid #1E40AF; padding:8px; text-align:center;">${totalMarks}</td>
          </tr>
          <tr style="font-weight:bold; background-color:#e2e8f0;">
            <td colspan="3" style="border:1px solid #1E40AF; padding:8px; text-align:right;">Percentage</td>
            <td style="border:1px solid #1E40AF; padding:8px; text-align:center;">${percentage}%</td>
          </tr>
          <tr>
            <td colspan="4" style="padding:20px 8px 8px 8px; text-align:left;"><strong>Remark:</strong> ${student.remark || "N/A"}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <div style="text-align:center; margin-top:40px;">
        <hr style="width:200px; margin-bottom:4px; border:1px solid #1E40AF;" />
        <span>Class Teacher</span>
      </div>
    `;
    container.appendChild(card);

    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
    html2canvas(card, { scale: 2 }).then(canvasEl => {
      const imgData = canvasEl.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      container.innerHTML = "";
      pdf.save(`ReportCard_${student.studentName}.pdf`);
    });
  };
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6">
      {/* FORM GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        <div>
          <label className={labelStyle}>Class</label>
          <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} className={inputBase} style={inputBorder}>
            <option value="">Select Class</option>
            {classes.map(c => <option key={c._id} value={c.className}>{c.className}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Section</label>
          <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} disabled={!selectedClass} className={inputBase} style={inputBorder}>
            <option value="">Select Section</option>
            {sections.map(s => <option key={s._id} value={s.sectionName}>{s.sectionName}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Exam</label>
          <select value={selectedExam} onChange={e => setSelectedExam(e.target.value)} className={inputBase} style={inputBorder}>
            <option value="">Select Exam</option>
            {exams.map(e => <option key={e._id} value={e.examName}>{e.examName}</option>)}
          </select>
        </div>
      </div>

      {/* SUBJECTS */}
      <h2 className="font-semibold text-black mb-4" style={{ fontSize: "18px" }}>Subjects & Total Marks</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        {subjects.map(sub => (
          <div key={sub._id}>
            <label className={labelStyle}>{sub.subjectName}</label>
            <input type="number" value={subjectMarks[sub.subjectName] ?? ""} onChange={e => handleSubjectMarksChange(sub.subjectName, e.target.value)} className={inputBase} style={inputBorder} />
          </div>
        ))}
      </div>

      {/* STUDENT SCORES */}
      <h2 className="font-semibold text-black mb-4" style={{ fontSize: "18px" }}>Student Scores</h2>
      <div className="overflow-x-auto mb-8">
        <table className="min-w-full border border-gray-300 text-left">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 font-semibold text-black text-[18px]">#</th>
              <th className="px-4 py-2 font-semibold text-black text-[18px]">Roll</th>
              <th className="px-4 py-2 font-semibold text-black text-[18px]">Name</th>
              {subjects.map(s => (
                <th key={s._id} className="px-4 py-2 font-semibold text-black text-[18px]">
                  {s.subjectName}
                </th>
              ))}
              <th className="px-4 py-2 font-semibold text-black text-[18px]">Total</th>
              <th className="px-4 py-2 font-semibold text-black text-[18px]">%</th>
              <th className="px-4 py-2 font-semibold text-black text-[18px]">Remark</th>
            </tr>
          </thead>
          <tbody>
            {students.length ? students.map((st, i) => (
              <React.Fragment key={st._id}>
                <tr className="even:bg-white odd:bg-gray-50">
                  <td rowSpan={2} className="px-4 py-2 text-[14px]">{i + 1}</td>
                  <td rowSpan={2} className="px-4 py-2 text-[14px]">{st.rollNo}</td>
                  <td rowSpan={2} className="px-4 py-2 text-[14px]">{`${st.firstName} ${st.lastName}`}</td>
                  {subjects.map(sub => (
                    <td key={sub._id} className="px-4 py-2">
                      <input
                        type="number"
                        placeholder="SA"
                        value={scores[st._id]?.[sub.subjectName]?.sa ?? ""}
                        onChange={e =>
                          handleSAMarksChange(
                            st._id,
                            sub.subjectName,
                            e.target.value
                          )
                        }
                        className="w-20 text-[14px] bg-white px-3 py-2 rounded-lg"
                        style={inputBorder}
                      />
                    </td>
                  ))}
                  <td rowSpan={2} className="px-4 py-2 text-[14px]">{calculateTotal(st._id)}</td>
                  <td rowSpan={2} className="px-4 py-2 text-[14px]">{calculatePercentage(st._id)}%</td>
                  <td rowSpan={2} className="px-4 py-2">
                    <input
                      type="text"
                      value={remarks[st._id] ?? ""}
                      onChange={e => handleRemarkChange(st._id, e.target.value)}
                      className="text-[14px] px-3 py-2 rounded-lg w-full bg-white"
                      style={inputBorder}
                    />
                  </td>
                </tr>
                <tr className="even:bg-white odd:bg-gray-50">
                  {subjects.map(sub => (
                    <td key={sub._id} className="px-4 py-2">
                      <input
                        type="number"
                        placeholder="Assessment"
                        value={scores[st._id]?.[sub.subjectName]?.assessment ?? ""}
                        onChange={e =>
                          handleAssessmentChange(
                            st._id,
                            sub.subjectName,
                            e.target.value
                          )
                        }
                        className="w-24 text-[14px] bg-white px-3 py-2 rounded-lg"
                        style={inputBorder}
                      />
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            )) : (
              <tr><td className="px-4 py-4 text-center" colSpan={subjects.length + 7}>No students available</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* BUTTONS */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button
  onClick={handleSubmit}
  disabled={loading}
  className="text-white"
  style={{
    ...button18,
    background: loading ? "#9ca3af" : colors.gradientPrimary,
    boxShadow: loading ? "none" : "0 4px 12px rgba(0,0,0,0.2)",
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.85 : 1,
  }}
>
  {loading
    ? "Please wait..."
    : isEditing
      ? "Update Result"
      : "Submit Result"}
</button>

        <button onClick={resetForm} className="bg-white border border-gray-300 hover:bg-gray-100" style={button18}>Reset</button>
      </div>
      {/* SAVED EXAM RESULTS */}
      <h2 className="font-semibold text-black mt-10 mb-4" style={{ fontSize: "18px" }}>Saved Exam Results</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 text-left">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-[18px]">#</th>
              <th className="px-4 py-2 text-[18px]">Class</th>
              <th className="px-4 py-2 text-[18px]">Section</th>
              <th className="px-4 py-2 text-[18px]">Exam</th>
              <th className="px-4 py-2 text-[18px]">Actions</th>
            </tr>
          </thead>
          <tbody>
            {examResults.length ? examResults.map((res, i) => (
              <tr key={res._id} className="even:bg-white odd:bg-gray-50">
                <td className="px-4 py-2 text-[14px]">{i + 1}</td>
                <td className="px-4 py-2 text-[14px]">{res.className}</td>
                <td className="px-4 py-2 text-[14px]">{res.sectionName}</td>
                <td className="px-4 py-2 text-[14px]">{res.examName}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEdit(res._id)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    style={{ fontSize: "14px" }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(res._id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    style={{ fontSize: "14px" }}
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => setViewingResult(res)}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                    style={{ fontSize: "14px" }}
                  >
                    View
                  </button>
                </td>
              </tr>
            )) : (
              <tr><td className="px-4 py-4 text-center" colSpan={5}>No results available</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* VIEW RESULT MODAL/SECTION */}
      {viewingResult && (
        <div className="mt-6 p-4 border border-gray-300 rounded bg-white">
          <h3 className="font-semibold text-[18px] mb-2">Exam: {viewingResult.examName}</h3>
          <p className="text-[14px] mb-2">Class: {viewingResult.className} | Section: {viewingResult.sectionName}</p>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-[14px]">#</th>
                  <th className="px-4 py-2 text-[14px]">Roll</th>
                  <th className="px-4 py-2 text-[14px]">Name</th>
                  {viewingResult.subjects.map((sub, idx) => (
                    <th key={idx} className="px-4 py-2 text-[14px]">{sub.subjectName}</th>
                  ))}
                  <th className="px-4 py-2 text-[14px]">Total</th>
                  <th className="px-4 py-2 text-[14px]">%</th>
                  <th className="px-4 py-2 text-[14px]">Remark</th>
                  <th className="px-4 py-2 text-[14px]">Report Cards</th>
                </tr>
              </thead>
              <tbody>
                {viewingResult.students.map((st, idx) => {
                  const total = st.scores.reduce((sum, s) => {
                    const sa =
                      parseFloat(s.sa ?? s.saMarks) || 0;
                    const assessment =
                      parseFloat(s.assessment ?? s.assessmentMarks) || 0;

                    return (
                      sum +
                      (s.score !== undefined && s.score !== null
                        ? parseFloat(s.score) || 0
                        : sa + assessment)
                    );
                  }, 0);

                  const maxTotal = viewingResult.subjects.reduce(
                    (sum, s) => sum + (parseFloat(s.totalMarks) || 0),
                    0
                  );

                  const percentage = maxTotal
                    ? ((total / maxTotal) * 100).toFixed(2)
                    : "0.00";

                  return (
                    <tr key={st.studentId} className="even:bg-white odd:bg-gray-50">
                      <td className="px-4 py-2 text-[14px]">{idx + 1}</td>
                      <td className="px-4 py-2 text-[14px]">{st.rollNo}</td>
                      <td className="px-4 py-2 text-[14px]">{st.studentName}</td>
                      {viewingResult.subjects.map((sub, i) => {
                        const scoreItem =
                          st.scores.find(
                            s => s.subjectName === sub.subjectName
                          ) || {};

                        const sa =
                          parseFloat(
                            scoreItem.sa ?? scoreItem.saMarks
                          ) || 0;

                        const assessment =
                          parseFloat(
                            scoreItem.assessment ??
                              scoreItem.assessmentMarks
                          ) || 0;

                        const subjectTotal =
                          scoreItem.score !== undefined &&
                          scoreItem.score !== null
                            ? parseFloat(scoreItem.score) || 0
                            : sa + assessment;

                        return (
                          <td
                            key={i}
                            className="px-4 py-2 text-[14px]"
                          >
                            <div className="flex flex-col gap-1">
                              <span>SA: {sa}</span>
                              <span>Assessment: {assessment}</span>
                              <span className="font-semibold">
                                Total: {subjectTotal}
                              </span>
                            </div>
                          </td>
                        );
                      })}
                      <td className="px-4 py-2 text-[14px]">{total}</td>
                      <td className="px-4 py-2 text-[14px]">{percentage}%</td>
                      <td className="px-4 py-2 text-[14px]">{st.remark}</td>
                      <td>
                        <button
                          onClick={() => generatePDFReportCardForStudent(viewingResult, st.studentId)}
                          className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
                          style={{ fontSize: "14px" }}
                        >
                          Generate PDF Report Card
                        </button>
                      </td>


                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            onClick={() => setViewingResult(null)}
            className="mt-4 px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            style={{ fontSize: "14px" }}
          >
            Close
          </button>



        </div>
      )}

      <div
        id="pdf-reportcard-container"
        style={{
          position: "fixed",
          left: "-9999px",
          top: 0,
          width: "800px",
          height: "auto",
          overflow: "hidden",
          zIndex: "-1",
        }}
      ></div>

    </div>

  );

};

export default ExamResultForm;
